/**
 * Format a given date timestamp using Gmail's approach:
 * - If on the same day, time only: 17:08
 * - Else, if on the same year, day and month only: 08 set.
 * - Else, full date: 15/06/2021
 * @param {number} timestamp
 * @returns string
 */
const getFormattedDate = (timestamp) => {
  const currentTime = new Date();
  const inputDate = new Date(timestamp);

  if (currentTime.toDateString() === inputDate.toDateString()) {
    const options = { hour: 'numeric', minute: 'numeric' };
    return new Intl.DateTimeFormat('pt-BR', options).format(inputDate);
  }

  if (currentTime.getFullYear() === inputDate.getFullYear()) {
    const options = { day: '2-digit', month: 'short' };
    return new Intl.DateTimeFormat('pt-BR', options).format(inputDate);
  }

  return new Intl.DateTimeFormat('pt-BR').format(inputDate);
};

export default getFormattedDate;
